<template>
	<div>
		<div
			id="panel_advices"
			class="panel advices"
			:class="[
				isHeaderIndent? 'mt-0 pt-1' : '',
				isFooterIndent? 'mb-0 pb-1' : '',
			]"
		>
			<div class="container">
				<div class="panel_header">
					<div class="row align-items-end">
						<div class="col-12 col-lg-6">
							<h2 v-if="block.block_title === null">
								Рекомендуем
							</h2>
							<h2
								v-else
							>
								{{ block.block_title }}
							</h2>
						</div>
					</div>
				</div>
				<div class="row">
					<div
						v-for="(item, index) in block.items"
						class="col-12 col-md-6 col-lg-6 mb-4"
						:class="{'d-none d-md-block d-lg-none' : index === 9}"
					>
						<div :class="'useful-item ' + contentIconMap[item.content_type]">
							<div>
								<div class="useful-item_top">
									<div class="tag_string">
										<span
											v-for="author in item.authors"
											v-if="item.authors !==null"
										>
											{{ author.title }}
										</span>
									</div>
									<div
										class="date"
										:class="[
											'block_title_icon',
											'block_title_icon-' + item.type
										]"
									>
										{{ item.date | moment('DD MMMM YYYY') }}
									</div>
								</div>
								<a
									v-if="!item.is_has_blocks && item.project_content_download_link"
									:href="item.project_content_download_link"
									class="title"
									target="_blank"
								>
									{{ item.title }}
								</a>
								<nuxt-link
									v-else
									:to="$url.media(item.slugs[2].slug, fetchedData.taxonomy_type_slug, {}, fetchedData.lang)"
									class="title"
								>
									{{ item.title }}
								</nuxt-link>
							</div>
							<div v-if="item.content_type === 1" class="useful-item_bottom">
								<a
									v-if="!item.is_has_blocks && item.project_content_download_link"
									:href="item.project_content_download_link"
									class="more_link"
									target="_blank"
								>
									{{ $t('watch') }}
								</a>
								<nuxt-link
									v-else
									:to="$url.media(item.slugs[2].slug, fetchedData.taxonomy_type_slug, {}, fetchedData.lang)"
									class="more_link"
								>
									{{ $t('watch') }}
								</nuxt-link>
							</div>
							<div v-else-if="item.content_type === 2" class="useful-item_bottom">
								<a
									v-if="!item.is_has_blocks && item.project_content_download_link"
									:href="item.project_content_download_link"
									class="more_link"
									target="_blank"
								>
									{{ $t('listen') }}
								</a>
								<nuxt-link
									v-else
									:to="$url.media(item.slugs[2].slug, fetchedData.taxonomy_type_slug, {}, fetchedData.lang)"
									class="more_link"
								>
									{{ $t('listen') }}
								</nuxt-link>
							</div>
							<div v-else-if="item.content_type === 0" class="useful-item_bottom">
								<a
									v-if="!item.is_has_blocks && item.project_content_download_link"
									:href="item.project_content_download_link"
									class="more_link"
									target="_blank"
								>
									{{ $t('read') }}
								</a>
								<nuxt-link
									v-else
									:to="$url.media(item.slugs[2].slug, fetchedData.taxonomy_type_slug, {}, fetchedData.lang)"
									class="more_link"
								>
									{{ $t('read') }}
								</nuxt-link>
							</div>
							<div v-else class="useful-item_bottom">
								<a
									v-if="!item.is_has_blocks && item.project_content_download_link"
									:href="item.project_content_download_link"
									class="more_link"
									target="_blank"
								>
									{{ $t('more') }}
								</a>
								<nuxt-link
									v-else
									:to="$url.media(item.slugs[2].slug, fetchedData.taxonomy_type_slug, {}, fetchedData.lang)"
									class="more_link"
								>
									{{ $t('more') }}
								</nuxt-link>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import '@/utils/moment';
import panel from '~/mixins/panel';

export default {
	name: 'PanelRecommendedArticles',
	mixins: [panel],
	data() {
		return {
			contentIconMap: {
				0: 'text',
				1: 'video',
				2: 'audio',
			},
		};
	},
	mounted() {
		console.log(this.block.items);
	},
};
</script>

<style lang="scss" scoped>
	@import '~/assets/styles/components/blocks/issue-useful-content-panel';
	@import "/assets/styles/components/blocks/issue-graduate-tips";
</style>
